// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loader__loader___2DLKy","bar":"Loader__bar___12onD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Loader/Loader.scss
// module id = 1479
// module chunks = 0